export enum ApprovalFlowAction {
Approve,
Check,
Notice,
}
